import { create } from 'zustand';

export const useFilterStore = create((set) => ({
  // Filtros Globais da Tabela / Base
  resultSearchInput: '',
  setResultSearchInput: (val) => set({ resultSearchInput: val }),

  categoryFilter: [],
  setCategoryFilter: (val) => set({ categoryFilter: typeof val === 'function' ? val() : val }),

  sourceFilter: 'all',
  setSourceFilter: (val) => set({ sourceFilter: val }),

  resultStateFilter: 'all',
  setResultStateFilter: (val) => set({ resultStateFilter: val }),

  contactFilter: 'all',
  setContactFilter: (val) => set({ contactFilter: val }),

  // Helpers
  clearFilters: () => set({
    resultSearchInput: '',
    categoryFilter: [],
    sourceFilter: 'all',
    resultStateFilter: 'all',
    contactFilter: 'all'
  })
}));
